import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/** Loads the CARENEST profession / specialty taxonomy once. */
export const useTaxonomy = () => {
  const [professions, setProfessions] = useState([]);

  useEffect(() => {
    api
      .get("/api/marketplace/taxonomy")
      .then((r) => setProfessions(r.data.professions))
      .catch(() => setProfessions([]));
  }, []);

  return professions;
};
